import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAdminVerification } from "../hooks/useAdminVerification";
import { Loader2 } from "lucide-react";

/**
 * Protegge le route che un admin deve poter raggiungere PRIMA di aver
 * completato la 2FA (registrazione e challenge del fattore TOTP):
 * verifica solo l'appartenenza a admin_users, senza richiedere aal2 —
 * altrimenti un admin senza fattore registrato non potrebbe mai
 * raggiungere la pagina di registrazione.
 */
const AdminOnlyRoute = (): React.ReactElement | null => {
	const { user, verifying, verified } = useAdminVerification();
	const location = useLocation();

	if (verifying) {
		return (
			<div className="flex items-center justify-center min-h-screen">
				<Loader2 className="h-8 w-8 animate-spin text-primary" />
			</div>
		);
	}

	if (!user) {
		return <Navigate to="/auth" state={{ from: location }} replace />;
	}

	if (!verified) {
		return <Navigate to="/" replace />;
	}

	return <Outlet />;
};

export default AdminOnlyRoute;
